import axios from "./axiosInstance";

// ─── Owner (business) ────────────────────────────────────────────────────────

export const createList = (name, ownerType = "venue", settings = {}) =>
  axios.post("/roster/list", { name, ownerType, ...settings }).then((r) => r.data);

export const getMyLists = () =>
  axios.get("/roster/lists").then((r) => r.data);

export const getListById = (listId) =>
  axios.get(`/roster/lists/${listId}`).then((r) => r.data);

export const updateListType = (listId, type) =>
  axios.patch(`/roster/lists/${listId}/type`, { type }).then((r) => r.data);

export const updateListSettings = (listId, settings) =>
  axios.patch(`/roster/lists/${listId}/settings`, settings).then((r) => r.data);

export const updateListDisplay = (listId, displayName) =>
  axios.patch(`/roster/lists/${listId}/display`, { displayName }).then((r) => r.data);

export const deleteList = (listId) =>
  axios.delete(`/roster/lists/${listId}`).then((r) => r.data);

// userId: direct add from search; identifier: username/email fallback
export const addPerformer = (listId, { userId, identifier }) =>
  axios.post(`/roster/lists/${listId}/add`, { userId, identifier }).then((r) => r.data);

export const removeMember = (listId, userId) =>
  axios.delete(`/roster/lists/${listId}/remove/${userId}`).then((r) => r.data);

export const getListCommitments = (listId) =>
  axios.get(`/roster/lists/${listId}/commitments`).then((r) => r.data);

export const getMemberCommitments = (listId, userId) =>
  axios.get(`/roster/lists/${listId}/members/${userId}/commitments`).then((r) => r.data);

export const getPendingRequests = (listId) =>
  axios.get(`/roster/lists/${listId}/requests`).then((r) => r.data);

export const acceptRequest = (listId, userId) =>
  axios.post(`/roster/lists/${listId}/requests/${userId}/accept`).then((r) => r.data);

export const declineRequest = (listId, userId) =>
  axios.post(`/roster/lists/${listId}/requests/${userId}/decline`).then((r) => r.data);

// ─── Performer (any authenticated user) ──────────────────────────────────────

export const browseLists = ({ search, ownerType, page = 1, limit = 20 } = {}) => {
  const params = { page, limit };
  if (search) params.search = search;
  if (ownerType) params.ownerType = ownerType;
  return axios.get("/roster/browse", { params }).then((r) => r.data);
};

export const joinOrRequest = (listId, note) =>
  axios.post(`/roster/join/${listId}`, note ? { note } : {}).then((r) => r.data);

export const leaveList = (listId) =>
  axios.delete(`/roster/leave/${listId}`).then((r) => r.data);

export const getMyListCommitments = (listId) =>
  axios.get(`/roster/leave/${listId}/commitments`).then((r) => r.data);

export const getMyMemberships = () =>
  axios.get("/roster/my-memberships").then((r) => r.data);

export const getMyRequests = () =>
  axios.get("/roster/my-requests").then((r) => r.data);

export const getMyInvites = () =>
  axios.get("/roster/my-invites").then((r) => r.data);

export const acceptInvite = (token) =>
  axios.post(`/roster/my-invites/${token}/accept`).then((r) => r.data);

export const declineInvite = (token) =>
  axios.delete(`/roster/my-invites/${token}`).then((r) => r.data);

export const resendInvite = (listId, email) =>
  axios.post(`/roster/lists/${listId}/invites/resend`, { email }).then((r) => r.data);

export const revokeInvite = (listId, email) =>
  axios.delete(`/roster/lists/${listId}/invites`, { data: { email } }).then((r) => r.data);

export const getRosterAutomationMetadata = () =>
  axios.get("/roster/automation-metadata").then((r) => r.data);

export const getRosterAutomations = (listId, params) =>
  axios.get(`/roster/lists/${listId}/automations`, { params }).then((r) => r.data);

export const createRosterAutomation = (listId, payload) =>
  axios.post(`/roster/lists/${listId}/automations`, payload).then((r) => r.data);

export const updateRosterAutomation = (listId, ruleId, payload) =>
  axios.patch(`/roster/lists/${listId}/automations/${ruleId}`, payload).then((r) => r.data);

export const deleteRosterAutomation = (listId, ruleId) =>
  axios.delete(`/roster/lists/${listId}/automations/${ruleId}`).then((r) => r.data);

export const testRosterAutomation = (listId, payload) =>
  axios.post(`/roster/lists/${listId}/automations/test`, payload).then((r) => r.data);

// Public — no auth token needed; uses the same axios instance (no auth header if not logged in)
export const redeemRosterInvite = (token) =>
  axios.get("/roster/join", { params: { token } }).then((r) => r.data);

export const getRosterInviteAvailability = (token) =>
  axios.get(`/roster/invite/${token}`).then((r) => r.data);

export const respondToRosterInviteAvailability = (token, payload) =>
  axios.post(`/roster/invite/${token}/respond`, payload).then((r) => r.data);
